'use client';
import { isString, isNumber } from '@s7/utils';
import { isConvertibleColor } from '../../../modules/colors/impl/validators/validators.js';
import { toRGBA } from '../../../modules/colors/impl/toRGBA/toRGBA.js';

var rgba = function(color, alpha) {
    if (alpha === void 0) alpha = 1;
    if (!isString(color) || isNumber(alpha) && (alpha > 1 || alpha < 0)) {
        return "rgba(0, 0, 0, 1)";
    }
    if (!isConvertibleColor(color)) {
        return color;
    }
    var _toRGBA = toRGBA(color), r = _toRGBA.r, g = _toRGBA.g, b = _toRGBA.b;
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
};

export { rgba };
